import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import illustration from '@svg/illustrations/success_submit_request.svg';

const SuccessSubmitRequest = () => {
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="illustration" />
            <Typography className={styles.title} variant="h4">
                Support request submitted successfully
            </Typography>
            <Typography className={styles.description} variant="body3">
                Your request has been submitted and is under review. It may take some time for it to
                appear in your requests list. Our support team will get back to you as soon as
                possible.
            </Typography>
        </div>
    );
};

export default SuccessSubmitRequest;
